module.exports = __webpack_public_path__ + "static/media/QUICK-ETH.db011ead.png";